<template>
  <div id="nav" class="nav">
    <ul>
      <li><router-link :to="{ name: 'about' }" exact @click.native="closeMenu">公司简介</router-link></li>
      <li><router-link :to="{ name: 'system' }" @click.native="closeMenu">支付系统</router-link></li>
      <li><router-link :to="{ name: 'case' }" @click.native="closeMenu">成功案例</router-link></li>
      <li><router-link :to="{ name: 'contact' }" @click.native="closeMenu">联系我们</router-link></li>
      <li>
        <a href="javascript:void(0);" class="icon" @click="openMenu">
          <i></i><i></i><i></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'nav-bar',
  methods: {
    openMenu () {
      const nav = document.getElementById('nav')
      const navMask = document.createElement('div')
      navMask.id = 'navMask'
      navMask.className = 'nav_mask'
      navMask.addEventListener('click', this.closeMenu)
      if (nav.className === 'nav') {
        nav.className += ' responsive'
        document.body.appendChild(navMask)
        this.$root.navBarIsOpen = true
      } else {
        this.closeMenu()
      }
    },
    closeMenu () {
      const nav = document.getElementById('nav')
      nav.className = 'nav responsive closeNav'
      const navM = document.getElementById('navMask')
      if (navM) {
        navM.classList.add('hide_mask')
      }
      setTimeout(() => {
        // document.body.removeChild(navM)
        nav.className = 'nav'
      }, 700)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.nav {
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    li {
      display: inline-block;
      margin-right: 55px;
      &:last-child{margin-right: 0;}
      a {
        font-size: 1.17em;
        font-weight: 600;
        letter-spacing: 1.05px;
        color: #FFF;
      }
    }
    a.active {
      color: #fde576;
    }
    .icon{
      display: none;
      position: relative;
      z-index: 9;
      i{
        display: block;
        width: 1.2em;
        height: 3px;
        border-radius: 2px;
        margin: 6px;
        background-color: #FFF;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  .nav {
    ul {
      align-items: center;
      li {
        margin-right: 2.8em;
      }
      a.active {
        color: #fde576;
      }
    }
  }
}
@media screen and (max-width: 767.9px) {
  .nav {
    float: right;
    margin-top: .3em;
    ul {
      display: inline-block;
      text-align: center;
      margin: 0;
      li {
        &:not(:last-child) {display: none;}
        margin-right: 0;
        &:last-child{margin-right: 0;}
        a {
          font-size: 1.17em;
          font-weight: 600;
          letter-spacing: 1.05px;
          color: #FFF;
          &.icon{
            float: right;
            display: block;
          }
        }
      }
      a.active {
        color: #fde576;
      }
      .icon{
        display: block;
        height: 2em;
        i{
          display: block;
          width: 1.2em;
          height: 3px;
          border-radius: 2px;
          margin: 6px;
          background-color: #FFF;
        }
      }
    }
    &.responsive{
      display: inline-block;
      position: relative;
      top: 0;
      right: 0;
      ul{
        position: absolute;
        display: block;
        width: 200px;
        height: 100vh;
        top: -1.3em;
        right: -1em;
        padding: 3em 1em 0;
        background: #1e1e1e;
        box-shadow: -1px 0 5px rgba(0,0,0,.5);
        z-index: 9;
        animation: navBarAni .5s cubic-bezier(0.550, 0.085, 0.680, 0.530);
        @keyframes navBarAni {
          0%{
            right: -300px;
          }
          100%{
            right: -1em;
          }
        }

        li{
          display: block;
          text-align: left;
          padding: .5em 1em;
          margin: 1em 0;
          a{
            &.icon{
              position: absolute;
              height: 2em;
              right: .8em;
              top: 1.2em;
              cursor: pointer;
              i:nth-child(1){
                transform: rotate(45deg);
                margin-top: .5em;
              }
              i:nth-child(2){
                display: none;
              }
              i:nth-child(3){
                transform: rotate(-45deg);
                margin-top: -.49em;
              }
              &:active{
                i:nth-child(2){
                  display: block;
                  position: absolute;
                  width: 1.2em;
                  height: 1.2em;
                  top: -.34em;
                  right: 0;
                  background-color: #c3aa5b;
                  border-radius: 50%;
                  filter: blur(6px);
                  opacity: .2;
                }
              }
            }
          }
        }
      }
    }
    &.closeNav{
      ul{
        right: -300px;
        animation: close_nav .5s linear;
      }
      @keyframes close_nav {
        0%{
          right: -1em;
        }
        100%{
          right: -300px;
        }
      }
    }
  }
}
</style>
